import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  title: string;
  ytd: string | number | undefined;
  total: string | number | undefined;
  isLoading: boolean;
}

const CostSavingInfoBlock: React.FC<IProps> = ({ title, ytd, total, isLoading }) => {
  const { t } = useTranslation();
  return (
    <div className={style.infoBlock}>
      <div className={style.infoTitle}>{title}</div>
      <div className={style.infoTotalBlock}>
        <div className={style.ytdBlock}>
          <div className={style.infoValue}>
            {isLoading ? <SkeletonBlock className={style.skeletonYtdText} /> : ytd}
          </div>
          <div className={style.infoTotalTitle}>{t('Year To Date')}</div>
        </div>
        <div className={style.totalBlock}>
          <div className={style.infoValue}>
            {isLoading ? <SkeletonBlock className={style.skeletonTotalText} /> : total}
          </div>
          <div className={style.infoTotalTitle}>{t('Total')}</div>
        </div>
      </div>
    </div>
  );
};

export default CostSavingInfoBlock;
